import { PriceListArea } from './models/pricelist-area.model';

export const priceListPaths: Record<Exclude<PriceListArea, 'ONLINE'>, string> = {
  EU: 'eu',
  ROW: 'row',
};
